import {useQuery} from 'react-query';
import {compteFTP} from '../Types/service';
import {getCompteFTP} from '../Api/api';

export const useCompteFTPByBuId = (buId: string, enabled: boolean = true) => {
  return useQuery<any, any, compteFTP[]>(
    ['get-compte-ftp-by-buID', buId],
    () => getCompteFTP(buId),
    {enabled}
  );
};
